<template>
  <div class="row">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="tableImpr"
        title="체크리스트별 개선목록"
        :columns="grid.columns"
        :data="patrol.imprs"
        :gridHeight="gridHeight"
        :merge="grid.merge"
        :isTitle="true"
        :filtering="false"
        :gridHeightAuto="true"
        :columnSetting="false"
        :usePaging="false"
        @linkClick="linkClick"
      ></c-table>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="gridImpr"
        title="항목외 개선 목록"
        :columns="gridImpr.columns"
        :data="gridImpr.data"
        :gridHeight="gridHeight2"
        :isTitle="true"
        :filtering="false"
        :gridHeightAuto="true"
        :columnSetting="false"
        :usePaging="false"
        @linkClick="linkClick2"
      >
        <template slot="table-button">
          <q-btn-group outline >
            <c-btn v-if="editable && popupParam.saiPatrolId" label="개선요청" :showLoading="false"  icon="add" @btnClicked="addImpr" />
            <c-btn v-if="editable && popupParam.saiPatrolId" label="즉시조치" :showLoading="false"  icon="add" @btnClicked="addiimImpr" />
          </q-btn-group>
        </template>
      </c-table>
    </div>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'patrol-improve',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        saiPatrolId: '',
        ibmTaskTypeCd: '',
        requestContents: '',
        research: '',
      }),
    },
    patrol: {
      type: Object,
      default: () => ({
        saiPatrolId: '',  // 순회점검 일련번호
        plantCd: '',  // 사업장 코드
        patrolName: '',  // 순회명
        patrolStartDate: '',  // 순회시작일
        patrolEndDate: '',  // 순회종료일
        deptCd: '',  // 점검부서 코드
        deptName: '',  // 점검부서
        patrolResultCd: null,  // 특이사항
        patrolResultSummary: '',  // 순회결과요약
        patrolStepCd: null,  // 진행상태
        checkUserId: '',
        regUserId: '',  //
        places: [],
        deletePlaces: [],
        imprs: [],
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      grid: {
        merge: [
          { index: 0, colName: 'placeId' },
          { index: 1, colName: 'groupEquipClass' },
          { index: 2, colName: 'groupItemClass' },
          { index: 3, colName: 'saiPatrolResultId' },
        ],
        columns: [
          {
            name: 'placeName',
            field: 'placeName',
            label: '장소',
            align: 'center',
            sortable: false,
            style: 'width:100px',
          },
          {
            name: 'patrolItemName',
            field: 'patrolItemName',
            label: '점검항목',
            align: 'left',
            sortable: false,
            style: 'width:200px',
          },
          {
            name: 'ibmTitle',
            field: 'ibmTitle',
            label: '제목',
            align: 'left',
            type: 'link',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'ibmStepName',
            field: 'ibmStepName',
            label: '진행상태',
            align: 'center',
            style: 'width:100px',
            sortable: false
          },
        ],
        data: [],
      },
      gridImpr: {
        columns: [
          {
            name: 'ibmClassName',
            field: 'ibmClassName',
            label: '구분',
            align: 'center',
            style: 'width:80px',
            sortable: false,
          },
          {
            name: 'actionDeptName',
            field: 'actionDeptName',
            label: '조치부서',
            align: 'center',
            style: 'width:120px',
            sortable: false,
          },
          {
            name: 'ibmTitle',
            field: 'ibmTitle',
            label: '제목',
            align: 'left',
            style: 'width:300px',
            sortable: false,
            type: 'link',
          },
        
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      impListUrl: '',
      gridHeight: '',
      gridHeight2: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        patrol: {},
        closeCallback: null,
      },
    };
  },
  computed: {
  },
  watch: {
    'popupParam.research'() {
      this.getImprs();
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.sai.patrol.improve.url;
      this.impListUrl = selectConfig.sop.ibm.improve.others.url;
      // code setting
      // list setting
      this.gridHeight2 = (window.innerHeight - 658) + 'px';
      this.gridHeight = '350px';

      this.getImprs();
      this.getImpList();
    },
    getImprs() {
      if (this.popupParam.saiPatrolId) {
        this.$http.url = this.listUrl;
        this.$http.type = 'GET';
        this.$http.param = {
          saiPatrolId: this.popupParam.saiPatrolId
        };
        this.$http.request((_result) => {
          this.$set(this.patrol, 'imprs', _result.data)
        },);
      }
    },
    getImpList() { // 항목외 개선목록
      if (this.popupParam.saiPatrolId) {
        this.$http.url = this.impListUrl;
        this.$http.param = {ibmTaskTypeCd: 'ITT0000065', relationTableKey: this.popupParam.saiPatrolId};
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.gridImpr.data = _result.data;
        },);
      }
    },
    /* eslint-disable no-unused-vars */
    linkClick(data, row, num) {
      this.requestImprRow = row
      this.imprData = data;

      if (data.ibmClassCd === 'IC00000001') {
        this.popupOptions.title = '개선';
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprDetail.vue'}`);
      } else {
        this.popupOptions.title = '즉시조치';
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmDetail.vue'}`);
      }
      this.popupOptions.param = {
        sopImprovementId: data.sopImprovementId,
      };
      this.popupOptions.visible = true;
      if (num == '2') {
        this.popupOptions.closeCallback = this.closeAddImprPopup;
      } else {
        this.popupOptions.closeCallback = this.closeImprPopup;
      }
    },
    linkClick2(row){
      this.linkClick(row, row, '2');
    },
    closeImprPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getImprs();
    },
    addImpr() {
      this.popupOptions.title = '개선 요청';
      this.popupOptions.param = {
        requestContents: this.patrol.patrolName,
        relationTableKey: this.popupParam.saiPatrolId,
        ibmTaskTypeCd: 'ITT0000065',
      };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprRequest.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeAddImprPopup;
    },
    addiimImpr() {
      this.popupOptions.title = '즉시조치';
      this.popupOptions.param = {
        requestContents: this.patrol.patrolName,
        relationTableKey: this.popupParam.saiPatrolId,
        ibmTaskTypeCd: 'ITT0000065',
      };
        this.popupOptions.target = () => import(`${'@/pages/sop/ibm/imprImmediate.vue'}`);
      this.popupOptions.width = '80%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeAddImprPopup;
    },
    closeAddImprPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getImpList();
    }
  }
};
</script>
